import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormEventService } from '@hub/services/form-event.service';

const noop = () => {};

export const CUSTOM_INPUTSWITCH_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormInputSwitchComponent),
  multi: true
};

@Component({
  selector: 'fm-inputSwitch',
  templateUrl: 'form-inputSwitch.component.html',
  providers: [CUSTOM_INPUTSWITCH_CONTROL_VALUE_ACCESSOR]
})
export class FormInputSwitchComponent
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) {}

  tabindex: string;

  @Input('tabindex')
  set tabin(val: string) {
    this.tabindex = String(val);
  }

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  private innerValue: boolean;
  private numOfTabs: number = 0;

  ngOnInit() {
    this.formEventService.setIndex(parseInt(this.tabindex));
    const elem: HTMLElement = this.el.nativeElement;
    this.renderer.setStyle(elem, 'outline', 'none');
  }

  ngOnDestroy() {
  }

  get value(): any {
    return this.innerValue;
  }

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  onClick(event: any) {
    event.stopPropagation();
    this.formEventService.setFocusIn(true);
    this.formEventService.changeFocus(this.tabindex);
  }

  //Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  onChange(obj: { originalEvent: Event; value: boolean }) {
    if (obj.value !== this.innerValue) {
      this.writeValue(obj.value);
      this.onChangeCallback(obj.value);
    }
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}
